import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 10 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 28\" id=\"exclamation\"><path fill=\"currentColor\" d=\"M8 19.5V23c0 .547-.453 1-1 1H3c-.547 0-1-.453-1-1v-3.5c0-.547.453-1 1-1h4c.547 0 1 .453 1 1zM8.469 3l-.438 12c-.016.547-.484 1-1.031 1H3a1.044 1.044 0 01-1.031-1L1.531 3A.97.97 0 012.5 2h5c.547 0 .984.453.969 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol